import { Heading , Paragraph , Div, PlacementDiv, InternDiv, Svg } from './InsightStyles';
import React, { useEffect } from "react";
import InsightSvg from "../../assets/Suitboi2.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

export default function Insight() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <Heading>Insights</Heading>
      <Paragraph>
        Get valuable insights into your dream companies which will be handy in
        paving your way right into them.
      </Paragraph>
      {/* Flex container for insight cards */}
      <Div>
        <Svg src={InsightSvg} />
        {/* Placement Insights Card */}
        <PlacementDiv onClick={(event) => (navigate("/insight"))}>
          <h2 style={{ marginTop: "35px" }}>Placement Insights</h2>
          <p style={{ marginTop: "35px", marginLeft: "5px", marginRight: "5px" }}>
            Students appear for placements in the final year of their study,
            with the CDC following a One-Student-One-Job policy.
          </p>
        </PlacementDiv>
        {/* Intern Insights Card */}
        <InternDiv>
          <h2>Intern Insights</h2>
          <p>
            Students take up internships to gain first-hand experience of the
            professional world, generally during the second and third years of
            their academic programme.
          </p>
        </InternDiv>
      </Div>
    </>
  );
}
